import {
  Activate_Payment_Method,
  Constraint_Purchase_Threshold_Counting_Attribute,
  Ownership_Condition,
} from '@occc/graphql';

export const activatePaymentMethodLabels: Record<Activate_Payment_Method, string> = {
  [Activate_Payment_Method.MobileApp]: 'Mobile App',
};

export const ownershipConditionLabels: Record<Ownership_Condition, string> = {
  [Ownership_Condition.OwnsAll]: 'Owns all',
  [Ownership_Condition.OwnsAny]: 'Owns any',
  [Ownership_Condition.OwnsNone]: 'Owns none',
  [Ownership_Condition.DoesNotOwnAll]: 'Does not own all',
};

export const purchaseThresholdLabelByCount: Record<
  Constraint_Purchase_Threshold_Counting_Attribute,
  string
> = {
  [Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount]: 'money amount',
  [Constraint_Purchase_Threshold_Counting_Attribute.Quantity]: 'quantity',
  [Constraint_Purchase_Threshold_Counting_Attribute.UnitsCount]: 'units',
};
